import LocalizedStrings from 'react-localization';

export const Texts = new LocalizedStrings({
  en: {
    PavelOrlov: 'Pavel Orlov',
    AboutMeMenuItem: 'about me',
    ResumeMenuItem: 'CV',
    WorksMenuItem: 'works',
    ContactMenuItem: 'contact',

    AboutText: '<p>Hi, everyone! My name is Pavel Orlov.</p>'
                   + '<p>I\'m software developer.</p>'
                   + '<p>I\'m glad to see you on my site. You can order any software for you here.</p>'
                   + '<p>Your requests will be answered as quickly as possible!</p>',

    ResumeEducationTitle: 'Education',
    ResumeEducationInfo1: 'Sept 2006 – June 2010 Bachelor\'s Degree on "Computing Machines, Systems and Networks" in Moscow Power Engineering Institute (Technical University)',
    ResumeEducationInfo2: 'June 2010 – Feb 2012 Engeener\'s Degree on "Computing Machines, Systems and Networks" in Moscow Power Engineering Institute (Technical University)',
    ResumeWorkHistoryTitle: 'Career development',
    ResumeWorkHistoryFreelanceName: 'Self Employed',
    ResumeWorkHistoryFreelanceTitle: 'Software developer',
    ResumeWorkHistoryFreelancePeriod: 'Oct 2012 - Present',
    ResumeWorkHistoryFreelanceInfo:
            '<ul>'
            + '   <li>create software applications to different platforms</li>'
            + '   <li>design databases</li>'
            + '   <li>consult about design and developing</li>'
            + '</ul>',

    ResumeWorkHistoryAvitoName: 'Avito',
    ResumeWorkHistoryAvitoTitle: 'Golang Developer ',
    ResumeWorkHistoryAvitoPeriod: 'Aug 2024 - Present',
    ResumeWorkHistoryAvitoInfo:
      '<div>'
      + '   <p>Building software in moderation unit. High-load microservices architectures.</p>'
      + '   <ul>'
      + '       <li>Golang</li>'
      + '       <li>Postgres</li>'
      + '       <li>Redis</li>'
      + '       <li>k8s</li>'
      + '       <li>Grafana</li>'
      + '       <li>Kibana</li>'
      + '       <li>Apache Kafka</li>'
      + '   </ul>'
      + '</div>',

    ResumeWorkHistoryAlfaBankName: 'AlfaBank LLC',
    ResumeWorkHistoryAlfaBankTitle: '.NET Developer ',
    ResumeWorkHistoryAlfaBankPeriod: 'Nov 2019 - Aug 2024',
    ResumeWorkHistoryAlfaBankInfo:
            '<div>'
            + '   <p>Build new microservices for credit business. Work with:</p>'
            + '   <ul>'
            + '       <li>.NET 5.0 / .NET Core 2.x-3.x / .NET Framework</li>'
            + '       <li>ASP.NET Web API</li>'
            + '       <li>ASP.NET WebForms (upgrade to WebApi for back-end and React.js for front-end)</li>'
            + '       <li>Apache Kafka</li>'
            + '       <li>Entity Framework (migrate from SQL procedures)</li>'
            + '       <li>DI-containers</li>'
            + '       <li>MS SQL Server</li>'
            + '       <li>xUnit / NUnit</li>'
            + '   </ul>'
            + '</div>',

    ResumeWorkHistoryPravoName: 'Pravo.ru LLC',
    ResumeWorkHistoryPravoTitle: '.Net Developer',
    ResumeWorkHistoryPravoPeriod: 'Aug 2018 - Nov 2019',
    ResumeWorkHistoryPravoInfo:
            '<div>'
            + '   <p>Legal Tech Development. Work with:</p>'
            + '   <ul>'
            + '      <li>.NET Framework 4.x</li>'
            + '      <li>ASP.NET Web API 2.0</li>'
            + '      <li>Entity Framework 6.0 (Code First)</li>'
            + '      <li>Elasticsearch'
            + '      <li>DI-Container Autofac'
            + '      <li>DI-Container Castle Windsor'
            + '      <li>NUnit</li>'
            + '      <li>SignalR</li>'
            + '      <li>Hangfire</li>'
            + '      <li>Consul</li>'
            + '   </ul>'
            + '</div>',

    ResumeWorkHistoryLasertagName: 'Lasertag LLC',
    ResumeWorkHistoryLasertagTitle: 'Web Developer',
    ResumeWorkHistoryLasertagPeriod: 'Mar 2015 - Aug 2018',
    ResumeWorkHistoryLasertagInfo:
            '<div>'
            + '   <p>Fullstack development of all web projects in company</p>'
            + '   <ul>'
            + '      <li>Built new laser tag arena web portal <a href=\'https://cybertag.ru\' target=\'_blank\'>cybertag.ru</a> (Asp.NET MVC, SQL Server 2012, EF, Ninject, etc)</li>'
            + '      <li>Created new <a href=\'https://laserwar.com\' target=\'_blank\'>laserwar.com</a> web site (Asp.NET MVC, SQL Server 2014, EF, Ninject, etc)</li>'
            + '      <li>Updated and redesigned of <a href=\'http://laserwar.ru\' target=\'_blank\'>laserwar.ru</a> web site (PHP 5.6, DataLife Engine 12, JS): updated DLE to 12.0, added design templates, etc.</li>'
            + '      <li>Updated and redesign of <a href=\'https://laserwar.ru/shop/\' target=\'_blank\'>laserwar.ru/shop</a> web store (PHP 5.6, OpenCart 3.0, JS): updated OpenCart from 1.6 to 3.0, built new modules for shipment and payment, etc.'
            + '      <li>Updated other laser tag resources: business school, laser tag club, laser tag tournament, etc.'
            + '      <li>Created web api for updating firmwares of laser tag devices, checking licenses, etc. (Asp.NET Web Api, SQL Server 2014)'
            + '      <li>Created desktop applications like e-mail mass sender, direct IP call, etc.</li>'
            + '   </ul>'
            + '</div>',

    ResumeWorkHistoryAktivSystemsName: 'AktivSystems LLC',
    ResumeWorkHistoryAktivSystemsTitle: '.Net Developer',
    ResumeWorkHistoryAktivSystemsPeriod: 'Dec 2014 - Feb 2015',
    ResumeWorkHistoryAktivSystemsInfo:
            '<div>'
            + '   <p>Fullstack development of different web and desktop applications.</p>'
            + '   <ul>'
            + '      <li>Created data import utility for financial modelling software <a href=\'https://www.brixx.com\' target=\'_blank\'>"BrixxPlanner"</a> (Asp.NetMVC 4, MySQL 5.5)</li>'
            + '      <li>Created html email editor with mass mailing support (Embarcadero® Delphi® XE2 + Microsoft SQL Server 2008 R2)</li>'
            + '      <li>Created Outlook-plugin for business notification system <a href=\'https://www.approvalmax.com\' target=\'_blank\'>ApprovalMax</a> (C#, Add-In Express, Visual Studio Tools for Office)</li>'
            + '   </ul>'
            + '</div>',

    ResumeWorkHistoryEtnaName: 'ETNA-IT LLC',
    ResumeWorkHistoryEtnaDeptLeaderTitle: 'Chief of the development department',
    ResumeWorkHistoryEtnaDeptLeaderPeriod: 'Feb 2014 - Nov 2014',
    ResumeWorkHistoryEtnaDeptLeaderInfo:
            '   <ul>'
            + '      <li>employees work organization</li>'
            + '      <li>staff monitoring and control</li>'
            + '      <li>staff work planning</li>'
            + '      <li>report documentation control</li>'
            + '      <li>development of new and support of existing software products</li>'
            + '   </ul>',

    ResumeWorkHistoryEtnaSoftwareDeveloperTitle: 'Software developer',
    ResumeWorkHistoryEtnaSoftwareDeveloperPeriod: 'Nov 2012 - Jan 2014',
    ResumeWorkHistoryEtnaSoftwareDeveloperInfo:
            '   <ul>'
            + '      <li>created and updated software products for major customers (Gazprom, Inter RAOUES, Rosneft) at Safety and Health rights protection (BorlandDelphi 7, Oracle 9/10, Firebird 2.x)</li>'
            + '      <li>employees work organization</li>'
            + '   </ul>',

    ResumeWorkHistoryEtnaJuniorTitle: 'Junior software developer',
    ResumeWorkHistoryEtnaJuniorPeriod: 'Oct 2011 - Oct 2012',
    ResumeWorkHistoryEtnaJuniorInfo:
            '   <ul>'
            + '      <li>created and updated existed software products (Borland Delphi 7, Oracle 9/10, Firebird 2.x)</li>'
            + '      <li>built new releases of AIS Workplace Contol for Gazprom</li>'
            + '      <li>created portal of the pilot project of certification of workplaces on working conditions(<a href=\'https://arm.fss.ru\' target=\'_blank\'>arm.fss.ru</a>) by FSS request (Asp.net MVC 4, Oracle 10, NHibernate)</li>'
            + '   </ul>',
    ResumeUrl: '/api/downloadfile?fileId=66df3267-c194-4091-b9c7-491e9e8ec6d3',

    ButtonDownloadResume: 'download CV',

    WorksSharpAppsCount: 'client applications using C#',
    WorksDelphiAppsCount: 'client applications using Delphi',
    WorksWebAspNetCount: 'web applications using Asp.NET',
    WorksWebPhpCount: 'web applications using PHP',
    WorksSmallProjectsCount: 'small projects',
    WorksSharpAppsCountValue: '27',
    WorksDelphiAppsCountValue: '14',
    WorksWebAspNetCountValue: '14',
    WorksWebPhpCountValue: '5',
    WorksSmallProjectsCountValue: '30',
    WorksAlsoInfo: 'Also, the services are rendered on database design, support and renew existing systems, create VBA-scripts and others.',
    WorksProjectSite: 'project site',
    WorksProjectMore: 'details',
    WorkReleaseDate: 'Date of the first release',
    ProjectsAvailableInFullSite: 'Full list of projects is available in the full version of the site',

    ContactDoYouHaveAnyQuestions: 'Do you have any questions?',
    ContactAskForHelp: 'Ask for help',
    ContactInfo:
            '<p>I\'m always waiting for your questions and requests.</p>'
            + '<p>Send to me your questions and I\'ll answer you as quickly as possible.</p>',
    Name: 'Name',
    ButtonSend: 'Send',
    Message: 'Message',

    ContactSendErrorNameIsEmpty: 'Name field is empty',
    ContactSendErrorEmailIsEmpty: 'Email field is empty',
    ContactSendErrorMessageIsEmpty: 'Message field is empty',
    ContactSendErrorEmailIsNotValid: 'Email field isn\'t correct',
    MessageSuccessfullySended: 'Message successfully sended',
    Email: 'support@pavel-orlov.com',
    Phone: '+7 (950) 700 08 92',
    PhoneVal: '+79507000892',
    Skype: 'accurced88',

    DiscordVideoFitTitle: 'DiscordVideoFit Plugin v.1.0.4',
    DiscordVideoFitWhyTitle: 'What is it?',
    DiscordVideoFitWhy_1: "There are some negative things when you're using video chat in Discord:",
    DiscordVideoFitWhy_2: 'This plugin will fix all of these issues.',
    DiscordVideoFitWhyNotGood_1: 'If you change a focused window, Discord window will hide.',
    DiscordVideoFitWhyNotGood_2: "You can't change the minimum size of Discord window.",
    DiscordVideoFitWhyNotGood_3: "There are a lot of control buttons and elements when you're on a video call.",
    DiscordVideoFitStepsTitle: 'Installation guide',
    DiscordVideoFitStep_1: 'Download the latest version of the DiscordVideoFit plugin installer by the link:',
    DiscordVideoFitStep_2: 'Run the downloaded file. The window with steps to installation will be open.',
    DiscordVideoFitStep_2_1a: 'The first step is to install AlwaysOnTop Utility to move a window always on top in Windows OS. Press "Download and Open Archive" button to install it. You can install it manually by link',
    DiscordVideoFitStep_2_1b: 'You will see the DI icon in the system tray after running it. If you want to put a window on top, you will focus on it and press Space + Ctrl. You can change this combination in program settings.',
    DiscordVideoFitStep_2_2: 'The second step is to install the BetterDiscord. It is special tool expanding Discord to install custom plugins and themes. You can install it by pressing "Download and Install" button or by link near it. After running Discord with installed BetterDiscord you will see Plugins / Themes / Custom CSS menu items in program settings.',
    DiscordVideoFitStep_2_3: 'The third step is to install the plugin. You can press "Download and Install" for it. Also, you can download it manually by link and move plugin into BetterDiscord plugins folder.',
    DiscordVideoFitStep_2_4: 'The fourth step is to make the Discord window resizable and set the minimum size of it smaller. You can press "Clear" button and "Apply" for it. The minimum size of the window will set to zero.',
    DiscordVideoFitUsingStepTitle: 'How to use?',
    DiscordVideoFitUsingStep_1: 'After successfully instalation, you will see the new button near window control buttons (minimize, maximize and close).',
    DiscordVideoFitUsingStep_2: "If you press on it when you're on a call, the videofit mode will be activated. The videofit button will change own color to red.",
    DiscordVideoFitUsingStep_3: 'If you press it again, the videofit mode will be deactivated.',
    SmallScreenHeader: 'The screen size is too small!',
    SmallScreenInfo: 'Please, make the screen size larger or try to use the mobile version. It\'ll be more comfortable!',

    MetaDescriptionAbout: 'The main information about me, my development experience and technologies what I\'m using',
    MetaTitleAbout: 'About me | Pavel Orlov - software developer',
    MetaDescriptionResume: 'Information about my career development and work experience',
    MetaTitleResume: 'CV | Pavel Orlov - software developer',
    MetaDescriptionWorks: 'The list of software what I built with details',
    MetaTitleWorks: 'Projects | Pavel Orlov - software developer',
    MetaDescriptionContact: 'My contacts which you can use to order software development by me',
    MetaTitleContact: 'Contact | Pavel Orlov - software developer',
    MetaDescriptionDiscordVideoFit: 'My contacts which you can use to order software development by me',
    MetaTitleDiscordVideoFit: 'Discord plugin | Pavel Orlov - software developer',
    MetaDescriptionKeyWords: 'software development, order software, soft, pavel orlov, C++, cyberforum, delphi, C#, create web site, create database, access, mysql, sql server',
    FileSuccessfullyDownloaded: 'File successfully downloaded',
    BrowserIsNotSupported: 'The browser is not supported by react.js. Please, update or try other your browser to view the site.',
    PageNotFound: 'Page not found',
    ErrorTitle: 'Error',
    InfoTitle: 'Information',
  },
  ru: {
    PavelOrlov: 'Павел Орлов',
    AboutMeMenuItem: 'обо мне',
    ResumeMenuItem: 'резюме',
    WorksMenuItem: 'работы',
    ContactMenuItem: 'контакты',

    AboutText: '<p>Приветствую Вас! Меня зовут Павел Орлов.</p>'
                   + '<p>Я – разработчик программного обеспечения.</p>'
                   + '<p>Рад видеть Вас на своем сайте. Вы можете заказать у меня разработку ПО любой сложности и направленности.</p>'
                   + '<p>Ваши заявки не останутся без ответа!</p>',

    ResumeEducationTitle: 'Образование',
    ResumeEducationInfo1: '09.2006 – 06.2010 Бакалавр по специальности «Вычислительные машины, комплексы, системы и сети»',
    ResumeEducationInfo2: '06.2010 – 02.2012 Инженер по специальности «Вычислительные машины, комплексы, системы и сети»',
    ResumeWorkHistoryTitle: 'Опыт работы',
    ResumeWorkHistoryFreelanceName: 'Фриланс',
    ResumeWorkHistoryFreelanceTitle: 'ведущий программист',
    ResumeWorkHistoryFreelancePeriod: 'октябрь 2012 - наст. время',
    ResumeWorkHistoryFreelanceInfo:
            '<ul>'
            + '   <li>написание программного обеспечения на заказ</li>'
            + '   <li>проектирование и реализация баз данных</li>'
            + '   <li>консультативная помощь в разработке и проектировании</li>'
      + '</ul>',

    ResumeWorkHistoryAvitoName: 'Авито',
    ResumeWorkHistoryAvitoTitle: 'Golang Developer ',
    ResumeWorkHistoryAvitoPeriod: 'август 2024 - Present',
    ResumeWorkHistoryAvitoInfo:
      '<div>'
      + '   <p>Разработка юнита, связанного с модерацией контента. Микросервисная архитектура с высокой нагрузкой.</p>'
      + '   <ul>'
      + '       <li>Golang</li>'
      + '       <li>PostgreSQL</li>'
      + '       <li>Redis</li>'
      + '       <li>k8s</li>'
      + '       <li>Grafana</li>'
      + '       <li>Kibana</li>'
      + '       <li>Apache Kafka</li>'
      + '   </ul>'
      + '</div>',

    ResumeWorkHistoryAlfaBankName: 'АО "Альфа-банк"',
    ResumeWorkHistoryAlfaBankTitle: 'Главный .Net разработчик',
    ResumeWorkHistoryAlfaBankPeriod: 'ноябрь 2019 - наст. время',
    ResumeWorkHistoryAlfaBankInfo:
            '<div>'
            + '   <p>Доработка и развитие существующих кредитных продуктов (кредиты, факторинг, кредитные линии, гарантии, аккредитивы) для среднего регионального корпоративного бизнеса. Разработка новых микросервисов и разбиение крупного монолита на микросервисы. Перенос логики хранимых процедур в микросервисы. Разработка нового крупного продукта с микросервисной архитектурой с нуля.</p>'
            + '   <ul>'
            + '       <li>.NET 5.0 / .NET Core 2.x-3.x / .NET Framework</li>'
            + '       <li>ASP.NET Web API</li>'
            + '       <li>ASP.NET WebForms (upgrade to WebApi for back-end and React.js for front-end)</li>'
            + '       <li>Apache Kafka</li>'
            + '       <li>Entity Framework (migrate from SQL procedures)</li>'
            + '       <li>DI-containers</li>'
            + '       <li>MS SQL Server</li>'
            + '       <li>xUnit / NUnit</li>'
            + '   </ul>'
            + '</div>',

    ResumeWorkHistoryPravoName: 'АО "Право.ру"',
    ResumeWorkHistoryPravoTitle: '.Net Developer',
    ResumeWorkHistoryPravoPeriod: 'август 2018 - ноябрь 2019',
    ResumeWorkHistoryPravoInfo:
            '<div>'
            + '   <p>Реализация нового и доработка существующего функционала <a href=\'https://casebook.ru\' target=\'_blank\'>casebook.ru</a>. Крупный проект с микросервисной архитектурой.</p>'
            + '   <ul>'
            + '      <li>.NET Framework 4.x</li>'
            + '      <li>ASP.NET Web API 2.0</li>'
            + '      <li>Entity Framework 6.0 (Code First)</li>'
            + '      <li>Elasticsearch'
            + '      <li>DI-Container Autofac'
            + '      <li>DI-Container Castle Windsor'
            + '      <li>NUnit</li>'
            + '      <li>SignalR</li>'
            + '      <li>Hangfire</li>'
            + '      <li>Consul</li>'
            + '   </ul>'
            + '</div>',

    ResumeWorkHistoryLasertagName: 'ООО "ЛАЗЕРТАГ"',
    ResumeWorkHistoryLasertagTitle: 'Web Developer',
    ResumeWorkHistoryLasertagPeriod: 'Mar 2015 - Aug 2018',
    ResumeWorkHistoryLasertagInfo:
            '<div>'
            + '   <p>Разработка новых и доработка имеющихся веб-ресурсов компании. (full-stack)</p>'
            + '   <ul>'
            + '      <li>Разработан сайт аренного лазертаг-оборудования <a href=\'https://cybertag.ru\' target=\'_blank\'>cybertag.ru</a>. Выполнена интеграция сайта с программными продуктами по конфигурированию оборудования. (Asp.NET MVC, SQL Server 2012, EF, Ninject и т.д.)</li>'
            + '      <li>Разработан веб-сайт <a href=\'https://laserwar.com\' target=\'_blank\'>laserwar.com</a> web site (Asp.NET MVC, SQL Server 2014, EF, Ninject и т.д.) преимущественно для иностранных клиентов компании + несколько SPA на поддоменах.</li>'
            + '      <li>Полностью изменен дизайн и выполнен рефакторинг ранее существующего веб-сайта компании <a href=\'http://laserwar.ru\' target=\'_blank\'>laserwar.ru</a> web site (PHP 5.6, DataLife Engine 12, JS): обновление движка DLE до 12.0, доработка шаблонов и т.п.</li>'
            + '      <li>Полностью изменен дизайн и выполнен рефакторинг ранее существующего интернет-магазина <a href=\'https://laserwar.ru/shop/\' target=\'_blank\'>laserwar.ru/shop</a> (PHP 5.6, OpenCart 3.0, JS): обновление движка OpenCart с 1.6 до 3.0, разработка модулей доставки товара (на основании открытых и закрытых АПИ служб доставки (ПЭК, СДЭК, Деловые линии и т.д.) и оплаты (Тинькофф, Сбербанк, Единая касса).</li>'
            + '      <li>Поддержка и сопровождение нескольких отдельных веб-сайтов компании: интернет-сайт лазертаг-клуба laserwar, школы бизнеса лазервар, сайт международного лазертаг турнира, отдельных ресурсов по тематике лазертага, находящихся в ведении компании, нескольких форумов.</li>'
            + '      <li>Разработка веб-апи для обновления прошивок лазертаг-девайсов, проверки лицензий, обновления десктопного софта и т.п. (Asp.NET Web Api, SQL Server 2014)</li>'
            + '      <li>Разработка ПО для внутреннего использования (с целью оптимизации бизнес-процессов): утилита массовой рассылки электронных сообщений с использованием разработанной веб-службы, разработка службы для автозвонков с использованием IP-телефонии и т.д.</li>'
            + '   </ul>'
            + '</div>',

    ResumeWorkHistoryAktivSystemsName: 'AktivSystems',
    ResumeWorkHistoryAktivSystemsTitle: '.Net Developer',
    ResumeWorkHistoryAktivSystemsPeriod: 'декабрь 2014 - февраль 2015',
    ResumeWorkHistoryAktivSystemsInfo:
            '<div>'
            + '   <p>Удаленная разработка различных программных продуктов с использованием методологии Scrum</p>'
            + '   <ul>'
            + '      <li>Разработка импортера данных в систему финансового моделирования <a href=\'https://www.brixx.com\' target=\'_blank\'>"BrixxPlanner"</a> (Asp.Net MVC 4, MySQL 5.5)</li>'
            + '      <li>Разработка многофункционального HTML-редактора электронных писем с возможностью массовой рассылки (Embarcadero® Delphi® XE2 + Microsoft SQL Server 2008 R2)</li>'
            + '      <li>Разработка Outlook-плагина для системы оповещений <a href=\'https://www.approvalmax.com\' target=\'_blank\'>ApprovalMax</a> (C#, Add-In Express, Visual Studio Tools for Office)</li>'
            + '      <li>Задачи реализовываются для иностранных заказчиков (в основном, американских), постановка задач в JIRA на английском языке</li>'
            + '   </ul>'
            + '</div>',

    ResumeWorkHistoryEtnaName: 'ООО НПП "Этна-ИТ"',
    ResumeWorkHistoryEtnaDeptLeaderTitle: 'начальник сектора прикладного программирования отдела разработки программного обеспечения',
    ResumeWorkHistoryEtnaDeptLeaderPeriod: 'февраль 2014 - ноябрь 2014',
    ResumeWorkHistoryEtnaDeptLeaderInfo:
            '   <ul>'
            + '      <li>организация работы сотрудников в секторе</li>'
            + '      <li>контроль за выполнением обязанностей сотрудниками сектора</li>'
            + '      <li>организация текущего и перспективного планирования деятельности - коллектива сектора</li>'
            + '      <li>своевременное обеспечение составления необходимой отчетной документации</li>'
            + '      <li>контроль соблюдения сотрудниками сектора мероприятий по внутреннему распорядку</li>'
            + '      <li>участие в разработке документации по разрабатываемым и внедряемым программным средствам</li>'
            + '      <li>разработка новых и поддержка уже существующих программных продуктов</li>'
            + '   </ul>',

    ResumeWorkHistoryEtnaSoftwareDeveloperTitle: 'ведущий инженер-программист',
    ResumeWorkHistoryEtnaSoftwareDeveloperPeriod: 'ноябрь 2012 - январь 2014',
    ResumeWorkHistoryEtnaSoftwareDeveloperInfo:
            '   <ul>'
            + '      <li>Сопровождение ~30 программных продуктов для крупных заказчиков (ОАО «Газпром», ОАО «Интер РАО ЕЭС», ОАО «Роснефть») в области охраны труда, аттестации рабочих мест, нормирования труда и т.д. (Borland Delphi 7, Oracle 9/10, Firebird 2.x)</li>'
            + '      <li>Раздача задач инженерам сектора и контроль их выполнения.</li>'
            + '   </ul>',

    ResumeWorkHistoryEtnaJuniorTitle: 'инженер-программист',
    ResumeWorkHistoryEtnaJuniorPeriod: 'октябрь 2011 - октябрь 2012',
    ResumeWorkHistoryEtnaJuniorInfo:
            '   <ul>'
            + '      <li>Разработка новых и сопровождение уже имеющихся программных модулей (Borland Delphi 7, Oracle 9/10, Firebird 2.x)</li>'
            + '      <li>Участие в выпуске нескольких версий программного продукта АИС АР для ОАО «Газпром»</li>'
            + '      <li>Разработка портала пилотного проекта аттестации рабочих мест по условиям труда (<a href=\'https://arm.fss.ru\' target=\'_blank\'>arm.fss.ru</a>) по заказу фонда социального страхования (Asp.net MVC 4, Oracle 10, NHibernate)</li>'
            + '   </ul>',
    ResumeUrl: '/api/downloadfile?fileId=7d80523e-cbdc-4c17-aa5b-67d7aea250de',
    ButtonDownloadResume: 'скачать резюме',

    WorksSharpAppsCount: 'проектов на C# для клиентских ПК',
    WorksDelphiAppsCount: 'проектов на Delphi для клиентских ПК',
    WorksWebAspNetCount: 'полноценных веб-решений на Asp.Net',
    WorksWebPhpCount: 'веб-решений на PHP',
    WorksSmallProjectsCount: 'других небольших проектов',
    WorksSharpAppsCountValue: '27',
    WorksDelphiAppsCountValue: '14',
    WorksWebAspNetCountValue: '14',
    WorksWebPhpCountValue: '5',
    WorksSmallProjectsCountValue: '30',
    WorksAlsoInfo: 'Также были оказаны услуги по проектированию баз данных, доработке существующих систем, написании VBA-скриптов и др.',
    WorksProjectSite: 'сайт проекта',
    WorksProjectMore: 'подробнее',
    WorkReleaseDate: 'Дата первого релиза',
    ProjectsAvailableInFullSite: 'Список проектов с примерами доступен в полной версии сайта на ПК',

    ContactDoYouHaveAnyQuestions: 'Остались вопросы?',
    ContactAskForHelp: 'Оставить заявку',
    ContactInfo:
            '<p>Я всегда готов ответить на все Ваши вопросы по разработке программного обеспечения.</p>'
            + '<p>Пишите мне и я отвечу Вам так скоро, как только смогу.</p>',
    Name: 'Имя',
    ButtonSend: 'Отправить',
    Message: 'Сообщение',

    ContactSendErrorNameIsEmpty: 'Не указано имя',
    ContactSendErrorEmailIsEmpty: 'Не указан email',
    ContactSendErrorMessageIsEmpty: 'Не указано сообщение',
    ContactSendErrorEmailIsNotValid: 'Неверно указан email',
    MessageSuccessfullySended: 'Сообщение успешно отправлено',
    Email: 'support@pavel-orlov.com',
    Phone: '+7 (950) 700-08-92',
    PhoneVal: '+79507000892',
    Skype: 'accurced88',

    DiscordVideoFitTitle: 'DiscordVideoFit Plugin v.1.0.4',
    DiscordVideoFitWhyTitle: 'Зачем это нужно',
    DiscordVideoFitWhy_1: 'При использовании Discord для видеозвонков многие пользователи сталкиваются со следующими недостатками:',
    DiscordVideoFitWhy_2: 'Эти недостатки призван исправить данный plugin совместно с другими утилитами.',
    DiscordVideoFitWhyNotGood_1: 'Окно Discord нельзя сделать поверх всех окон во время разговора. Грубо говоря, когда Вы в момент разговора хотите сделать активным другое окно (браузер, MS Word и т.п.), то окно Discord скрывается за ним.',
    DiscordVideoFitWhyNotGood_2: 'Невозможно изменить размер окна Discord меньше стандартных минимальных размеров, вследствие чего окно Discord занимает большое пространство на экране.',
    DiscordVideoFitWhyNotGood_3: 'Невозможно сделать видео в момент разговора на все окно Discord (слишком много управляющих элементов).',
    DiscordVideoFitStepsTitle: 'Порядок установки',
    DiscordVideoFitStep_1: 'Скачиваем последнюю версию инсталлятора по ссылке:',
    DiscordVideoFitStep_2: 'Запускаем скачанный инсталлятор. Открывается окно с последовательным набором шагов, которые нужно выполнить.',
    DiscordVideoFitStep_2_1a: 'Шаг первый - устанавливаем утилиту AlwaysOnTop. Она позволяет размещать любое окно в ОС Windows поверх всех. Для установки нажимаем на кнопку "Download and Open Archive" или скачиваем утилиту вручную по предлагаемой ниже ссылке, кликнув на нее. Сама по себе утилита поставляется без установщика, достаточно просто запустить исполняемый файл. В трее появится значок "DI" после успешного запуска программы',
    DiscordVideoFitStep_2_1b: 'Чтобы разместить любое окно поверх всех, нужно сделать его активным/в фокусе и одновременно нажать пробел + Ctrl (комбинация горячих клавиш меняется в настройках программы).',
    DiscordVideoFitStep_2_2: 'Шаг второй: нужно установить BetterDiscord. Это расширение для Discord, которое позволяет устанавливать в Discord расширения/плагины/темы. Установить можно нажав "Download and Install" или по предлагаемой ссылке ниже. На некоторых системах с установкой этого расширения возникают проблемы, решения можно найти на официальном сайте программы. В большинстве случаев установка проходит без проблем. После запуска Discord при установленном BetterDiscord в настройках Discord появляются новые пункты: Plugins/ Themes / Custom CSS.',
    DiscordVideoFitStep_2_3: 'На третьем шаге устанавливаем сам plugin. Для этого нажимаем "Download and Install" и плагин установится автоматически. Также можно скачать его вручную по предлагаемой ссылке и поместить скачанный файл в папку с плагинами (в настроках Discord можно открыть этй папку, зайдя в раздел Plugins)',
    DiscordVideoFitStep_2_4: 'Четвертым этапом нужно сделать возможным уменьшение размера окна Discord до минимального. Для этого внизу окна в текстовых полях вводим нужные значения минимального размера ширины и высоты окна (по умолчанию выставлено текущее значение) и нажимаем кнопку Apply. Можно выставить в этих полях 0 - тогда окно можно будет уменьшать в размерах до 0. Кнопка Clear выставляет в текстовых полях 0 для ширины и высоты окна.',
    DiscordVideoFitUsingStepTitle: 'Порядок использования',
    DiscordVideoFitUsingStep_1: 'После успешного скачивания и установки плагина в Discord появляется новая кнопка рядом с кнопками свернуть/развернуть/закрыть для управления окном.',
    DiscordVideoFitUsingStep_2: 'Если на нее нажать во время видеозвонка, то активируется режим сокрытия управляющих элементов и видеокартинка разворачивается на все окно Discord. При этом иконка становится красной.',
    DiscordVideoFitUsingStep_3: 'При повторном нажатии происходит возврат в обычный режим отображения Discord.',
    SmallScreenHeader: 'Упс. Очень узко!',
    SmallScreenInfo: 'Сделайте экран браузера шире или перейдите на мобильную версию. Вам будет значительно удобнее.',

    MetaDescriptionAbout: 'Общая информация обо мне, статистике разработки программного обеспечения на заказ и используемых технологиях',
    MetaTitleAbout: 'Обо мне | Павел Орлов - страница разработчика',
    MetaDescriptionResume: 'Информация о технологиях и моем опыте, который я использую при разработке программного обеспечения на заказ',
    MetaTitleResume: 'Резюме | Павел Орлов - страница разработчика',
    MetaDescriptionWorks: 'Список программного обеспечения, разработку которого я выполнил на заказ',
    MetaTitleWorks: 'Мои работы | Павел Орлов - страница разработчика',
    MetaDescriptionContact: 'Контакты, которые можно использовать для связи со мной с целью заказа разработки программного обеспечения',
    MetaTitleContact: 'Контакты | Павел Орлов - страница разработчика',
    MetaDescriptionDiscordVideoFit: 'Плагин для discord, который можно использовать в видеозвонках',
    MetaTitleDiscordVideoFit: 'Плагин для discord | Павел Орлов - страница разработчика',

    MetaDescriptionKeyWords: 'заказать программу для компьютера, заказать программу на C++, заказать программу cyberforum, заказать программу на delphi, заказать программу на C#, заказать программу для диплома, разработать сайт для компании, разработать сайт, визитку, разработать сайт для предприятия, база данных создать программа, база данных создать delphi, база данных создать в access, база данных создать mysql, разработка аис склад продовольственного магазина, разработка аис диплом, разработка аис таксопарка, дипломный проект разработка по аис, персональная страница разработчика, программирование на заказ за деньги, программирование на заказ москва, программирование на заказ delphi, разработка базы данных sql server, разработка базы данных дипломная работа, разработка базы данных информационного портала, разработка приложений windows, разработка программ на заказ, написать программа',
    FileSuccessfullyDownloaded: 'Файл успешно скачан.',
    BrowserIsNotSupported: 'Ваш браузер не поддерживается. Пожалуйста, обновите браузер или используйте другой браузер для просмотра сайта.',
    PageNotFound: 'Страница не найдена',
    ErrorTitle: 'Ошибка',
    InfoTitle: 'Информационное сообщение',
  },
});

export default Texts;



// WEBPACK FOOTER //
// ./src/components/Texts.js